// apps/web/src/api/banks.ts
// 题库相关 API — 调用 /api/v1/banks/*

import api from "./client";
import type {
  BankDTO,
  CreateBankRequest,
  UpdateBankRequest,
  BankListResponse,
  BankPracticeRecordsResponse,
  BankTypePracticeStatsDTO,
  MergeBanksRequest,
  MergeBanksResponse,
} from "@examfast/shared-types";

export interface BankStatsDTO {
  question_count: number;
  wrong_count: number;
  favorite_count: number;
  note_count: number;
  answered_count: number;
  correct_count: number;
  wrong_answer_count: number;
  completion_rate: number;
  accuracy_rate: number;
}

export interface BankQuestionTypeStatsDTO {
  single_choice: number;
  multiple_choice: number;
  true_false: number;
  fill_blank: number;
  essay: number;
}

const BASE = "banks";

/** 获取题库列表 */
export async function listBanks(opts: { page?: number; page_size?: number; tag?: string } = {}): Promise<BankListResponse> {
  const params = new URLSearchParams();
  if (opts.page) params.set("page", String(opts.page));
  if (opts.page_size) params.set("page_size", String(opts.page_size));
  if (opts.tag) params.set("tag", opts.tag);
  const qs = params.toString();
  return api.get<BankListResponse>(`${BASE}${qs ? "?" + qs : ""}`);
}

/** 获取题库详情 */
export async function getBank(bankId: string): Promise<BankDTO> {
  return api.get<BankDTO>(`${BASE}/${bankId}`);
}

/** 获取题库统计 */
export async function getBankStatsApi(bankId: string): Promise<BankStatsDTO> {
  return api.get<BankStatsDTO>(`${BASE}/${bankId}/stats`);
}

/** 获取题库题型统计 */
export async function getBankQuestionTypeStatsApi(bankId: string): Promise<BankQuestionTypeStatsDTO> {
  return api.get<BankQuestionTypeStatsDTO>(`${BASE}/${bankId}/type-stats`);
}

export async function getBankTypePracticeStatsApi(bankId: string): Promise<BankTypePracticeStatsDTO> {
  return api.get<BankTypePracticeStatsDTO>(`${BASE}/${bankId}/type-practice-stats`);
}

export async function getBankPracticeRecordsApi(bankId: string): Promise<BankPracticeRecordsResponse> {
  return api.get<BankPracticeRecordsResponse>(`${BASE}/${bankId}/practice-records`);
}

export async function clearBankPracticeRecordsApi(bankId: string): Promise<void> {
  return api.del<void>(`${BASE}/${bankId}/practice-records`);
}

/** 创建题库 */
export async function createBankApi(data: CreateBankRequest): Promise<BankDTO> {
  return api.post<BankDTO>(BASE, data);
}

export async function mergeBanksApi(data: MergeBanksRequest): Promise<MergeBanksResponse> {
  return api.post<MergeBanksResponse>(`${BASE}/merge`, data);
}

/** 更新题库 */
export async function updateBankApi(bankId: string, data: UpdateBankRequest): Promise<BankDTO> {
  return api.put<BankDTO>(`${BASE}/${bankId}`, data);
}

/** 删除题库 */
export async function deleteBankApi(bankId: string): Promise<void> {
  return api.del<void>(`${BASE}/${bankId}`);
}
